import { InitXSRFProtection } from '@rhybus/api'


const formatHost = (host: string) => {
  if(location.host.indexOf('www.') === 0){
    return location.host.replace('www.','')
  }

  return host
}

export const sitePath = `${window.location.origin}`
export const siteHost = `${formatHost(window.location.host)}`

export const apiPath = process.env.REACT_APP_RHYBUS_API_URL + '/api'

export const fetchProvider = {
  Headers,
  Request,
  Response,
  fetch: window.fetch.bind(window),
}

/**
 * 
 * @returns true if call to InitXSRFProtection was successful
 *          false if an error occurred
 */
export async function xsrfInitEffect() {
  try {
    await InitXSRFProtection(fetchProvider, apiPath)
    return true
  } catch (error) {
    console.error('Failed to initialize XSRF protection', error)
    console.error('Local DEV? Visit /localdev and then retry to resolve.')
    
    if (error.name === 'TypeError') {
      window.location.href = '/localdev'
    }
    return false
  }
}
